'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import Header from '../common/Header';
import Footer from '../common/Footer';

export default function VariableLayout({ children }: { children: React.ReactNode }) {
    const pathname = usePathname();
    const isDashboard = pathname?.startsWith('/dashboard') || pathname?.startsWith('/for-students/dashboard');

    if (isDashboard) {
        return (
            <>
                {children}
            </>
        );
    }

    return (
        <>

            <Header />
            <main className="flex-grow pt-16">
                {children}
            </main>
            <Footer />
        </>
    );
}
